<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2"><em>This book is dedicated to all of you who say to me, “Yes, Leanne, you can do it.” You know who you are.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SomeGirlsDo_dedi-1.vue?728cfa72